import React, { useState, useEffect } from "react";
import close from "./close.svg";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const GreetingCard = ({
  headerImage,
  altText,
  salutation,
  message,
  greeting,
  onClose,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isFontLoaded, setIsFontLoaded] = useState(false);

  useEffect(() => {
    // Überprüfen, ob die Schriftart geladen ist
    const fontReady = async () => {
      await document.fonts.ready;
      setIsFontLoaded(true);
    };
    fontReady();
  }, []);

  return (
    <div className="greeting-card">
      <div className="header">
        <div className="close-button">
          <button onClick={onClose}>
            <img src={close} alt="Schliessen" />
          </button>
        </div>
        {!isImageLoaded && (
          <SkeletonTheme baseColor="#00021D" highlightColor="#1D1F33">
            <Skeleton className="header-image-skeleton" height={260} />
          </SkeletonTheme>
        )}
        <img
          className="header-image"
          src={headerImage}
          alt={altText}
          onLoad={() => setIsImageLoaded(true)}
          style={{ display: isImageLoaded ? "block" : "none" }}
        />
      </div>
      <div className="body">
        {!isFontLoaded ? (
          <SkeletonTheme baseColor="#00021D" highlightColor="#1D1F33">
            <Skeleton
              height={48}
              width={"80%"}
              className="salutation-skeleton"
            />
            <Skeleton height={24} width={"100%"} className="message-skeleton" />
            <Skeleton height={48} width={"60%"} className="greeting-skeleton" />
          </SkeletonTheme>
        ) : (
          <>
            <h2 className="salutation">{salutation}</h2>
            <pre className="message">{message}</pre>
            <h3 className="greeting">{greeting}</h3>
          </>
        )}
      </div>
    </div>
  );
};

export default GreetingCard;
